<template>
    <div>
        <h4>{{$t('PROMOTIONS.bulkPrices')}}</h4>
        <p v-if="promotions.length === 0">{{$t('PROMOTIONS.noPromotions')}}</p>
        <table class="table table-bordered table-hover promotions-table" v-else>
            <thead>
            <tr>
                <table-head-with-sort :text="$t('COMMON.product')"
                                      :showControls="false"/>
                <table-head-with-sort :text="$t('COMMON.quantity')"
                                      :sortType="'quantity'"
                                      @sort="handleSort"/>
                <table-head-with-sort :text="$t('COMMON.price')"
                                      :sortType="'price'"
                                      @sort="handleSort"/>
                <table-head-with-sort :text="$t('COMMON.active')"
                                      :sortType="'active'"
                                      @sort="handleSort"/>
                <table-head-with-sort :text="$t('UI.remove')"
                                      v-if="editMode"/>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(promotion, index) in sortPromotions"
                :key="`promotion-bulk-${promotion.id}-${index}`" >
                <td>{{getProductById(promotion.productId)}}</td>
                <td>From {{promotion.quantity}} photos</td>
                <td>
                    <vue-numeric :decimal-separator="decimalSeparator"
                                 :separator="separator"
                                 :currency="symbol"
                                 currency-symbol-position="suffix"
                                 :read-only="true"
                                 :precision="fractionalDigits"
                                 :value="promotion.price"></vue-numeric>
                </td>
                <td>
                    <div v-if="!editMode">{{promotion.active ? $t('COMMON.active') : $t('COMMON.inactive')}}</div>
                    <vue-checkbox-toggle
                        v-else
                        ref="checkbox"
                        v-model="promotion.active"
                        :value="promotion.active"
                        @focus="promotion.focused=true"
                        @clicked="activatePromotion(promotion)"
                    >
                    </vue-checkbox-toggle>
                </td>
                <td v-if="editMode">
                    <cph-button @clicked="removePromotion(promotion)"
                                :buttonText="'Remove'"
                                :classList="'btn btn-warning btn-sm'">
                    </cph-button>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import {mapGetters, mapMutations, mapActions} from 'vuex';
import PromotionMixin from './PromotionMixin';
import TableHeadWithSort from '../../Shared/UI/Table/TableHeadWithSort';
import VueNumeric from 'vue-numeric';
import VueCheckboxToggle from '../../Shared/Toggler';
import CphButton from '../../Shared/UI/Button/CphButton';

export default {
    name: 'ActiveBulkPromotions',
    props: {
        promotions: {
            type: [Array, Object]
        },
        symbol: '',
        edit: {
            type: Boolean,
            default: false
        },
        bulk: {
            type: Boolean,
            default: false
        },
        fractionalDigits: 0,
        decimalSeparator: {
            deafult: "."
        },
        separator: {
             default: ","
        }
    },
    data(){
        return {
            editMode: false
        }
    },
    mixins: [PromotionMixin],
    components: {
        TableHeadWithSort,
        VueNumeric,
        VueCheckboxToggle,
        CphButton,
    },
    computed: {
            ...mapGetters(['getDefaultProducts', 'getDefaultProductById']),
    },
    created(){
        this.editMode = this.edit || this.$route.name == 'FastEdit'
    },
    methods: {
        ...mapMutations(['updatePromotions']),
        getProductById(id){
            const product = this.getDefaultProductById(id)[0];
            if(product){
                if(product.formats && product.formats[0]){
                    return product.formats[0].displayString;
                }
                if(product.availableLayouts && product.availableLayouts[0]){
                    return product.availableLayouts[0].title;
                }
            }
            return id;
        },
        activatePromotion(promotion){
            const acState = {...promotion};
            if(this.bulk){
                this.$emit('bulkActivatePromotion', acState)
                return;
            }
            this.$emit("addFunctionToSave", {id: `${new Date().getTime()}-activate-bulk-update`, run: () => {
                this.$store.dispatch('updatePromotionAsync', acState);
                // console.log("acState 2", acState)
                // this.$store.dispatch('getFees');
            }})
            this.$emit('showInformationUpdateCubes')
            this.$emit('saveFunctions')
        },
        async removePromotion (promotion) {
            const {id} = promotion;
            const updatedPromotions = this.promotions.filter((promo) => promo.id !== id);

            this.$store.dispatch('confirmAction', {question: this.$t('QUESTIONS.removePromotion'),
                callback: (decision = false) => {
                    if(decision === true) {
                        this.updatePromotions(updatedPromotions);
                        if(this.bulk){
                            this.$emit('bulkRemovePromotion', id)
                            return;
                        }
                        this.$emit("addFunctionToSave", {
                            run: () => {
                                this.$store.dispatch('deletePromotionByIdAsync', id);
                            },
                            id: `${new Date().getTime()}-bulk-promotion-${id}-delete`
                        })
                        this.$emit("addFunctionToSave", {
                            run: () => {
                                this.$store.dispatch('getPromotionsAsync');
                            },
                            id: `${new Date().getTime()}-bulk-promotion-${id}-get`
                        })
                        this.$emit('showInformationUpdateCubes')
                        this.$emit('saveFunctions')
                    }
                }
            })
        },
    }
};
</script>
